































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import gql from 'graphql-tag';
import store from '@/store';
import { parseError, UNKNOWN_ERROR } from '@/utils/errors.ts';

const resetPasswordMutation = gql`
  mutation ResetPassword($email: String!) {
    resetPassword(email: $email)
  }
`;

@Component({
  components: {
  },
})
export default class Login extends Vue {
  public email: string | null = null;
  private fieldErrors: {[key: string]: string} = {};
  private formError: string | null = null;

  private loading = false;
  private submitted = false;

  public forgotPassword() {
    this.validateFields();
    if (this.hasErrors) {
      return;
    }

    this.loading = true;
    this.$apollo.mutate({
      mutation: resetPasswordMutation,
      variables: { email: this.email },
    }).then((response) => {
      this.loading = false;
      this.submitted = true;
    }).catch((e) => {
      this.formError = parseError(e) || UNKNOWN_ERROR;
      this.loading = false;
    });
  }

  get hasErrors() {
    return Object.values(this.fieldErrors).some((v) => v != null && v.length > 0);
  }

  public validateFields() {
    this.validateEmail();
  }

  public validateEmail() {
    const v = (this.email || '').trim();

    let err = null;
    if (v.length < 1) {
      err = `Your email address is required.`;
    }

    Vue.set(this.fieldErrors, 'email', err);
  }

  @Watch('email')
  public onEmailChange() {
    this.validateEmail();
  }
}
